import React from "react";
import Footer3 from "./Footer3";
import Footer4 from "./Footer4";
import Footer5 from "./Footer5";

export default function Footer() {
  return (
    <div>
      <Footer3 />
      {/* <Footer4 /> */}
      {/* <Footer5 /> */}
    </div>
  );
}
